import { MembroComissaoEleicaoResponseType, SummaryCardType } from '../../types';

import { ComissaoEleitoralMembrosList } from '.';
import { DefaultCard } from '../../components';
import { FaPen } from 'react-icons/fa';
import { FunctionComponent } from 'react';
import { Spinner } from '../../utils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ComissaoEleitoralSummaryCard: FunctionComponent<SummaryCardType<MembroComissaoEleicaoResponseType[]>> = ({
  domain,
  setState,
  idEleicao,
  permiteAlterarDadosEleicao,
  loading = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <DefaultCard
      cardTitle={t('label.comissao_eleitoral')}
      mainAction={() => {
        navigate(`/eleicoes/${idEleicao}/membros/alterar`);
      }}
      mainActionName={t('label.gerenciar_comissao_eleitoral')}
      mainActionIcon={FaPen}
      mainActionDisabled={!permiteAlterarDadosEleicao}
    >
      {loading ? (
        <Spinner />
      ) : (
        <ComissaoEleitoralMembrosList membrosComissao={domain!} idEleicao={idEleicao} setMembrosComissao={setState} />
      )}
    </DefaultCard>
  );
};

export default ComissaoEleitoralSummaryCard;
